import React from 'react';

const LogoSet = () => (
  <div className="flex items-center gap-14 sm:gap-20 shrink-0 opacity-70 hover:opacity-100 transition-opacity">
    {/* e& capital */}
    <a href="https://www.eand.com/en/capital.html" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 grayscale hover:grayscale-0 transition duration-300">
      <span className="font-extrabold text-xl tracking-tight text-slate-900">e&amp;</span>
      <span className="font-light tracking-widest text-xl text-emerald-600">capital</span>
    </a>

    {/* Roland Berger */}
    <a href="https://www.rolandberger.com/en/" target="_blank" rel="noopener noreferrer" className="font-bold tracking-[0.14em] text-sm sm:text-base text-slate-800 whitespace-nowrap font-sans grayscale hover:grayscale-0 transition duration-300 hover:text-black">
      ROLAND BERGER
    </a>

    {/* Nomura */}
    <a href="https://www.nomura.com/" target="_blank" rel="noopener noreferrer" className="font-serif font-bold tracking-tight text-lg sm:text-xl text-slate-900 whitespace-nowrap grayscale hover:grayscale-0 transition duration-300 hover:text-red-600">
      NOMURA
    </a>

    {/* IdeaSpring */}
    <a href="https://www.ideaspringcap.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 whitespace-nowrap grayscale hover:grayscale-0 transition duration-300">
      <span className="font-bold tracking-tight text-lg text-slate-900">IdeaSpring</span>
      <span className="text-[10px] font-mono text-slate-500 font-semibold uppercase mt-1">Capital</span>
    </a>

    {/* KRINS */}
    <a href="https://www.krins.or.kr/" target="_blank" rel="noopener noreferrer" className="font-black tracking-widest text-xl text-slate-900 whitespace-nowrap grayscale hover:grayscale-0 transition duration-300 hover:text-blue-700">
      KRINS
    </a>

    {/* DHL */}
    <a href="https://www.dhl.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 whitespace-nowrap grayscale hover:grayscale-0 transition duration-300">
      <span className="font-black italic tracking-wider text-2xl text-slate-900 hover:text-red-600">DHL</span>
    </a>
  </div>
);

export const TrustBar = () => {
  return (
    <section id="trust-bar" className="bg-white border-y border-slate-200 py-6 sm:py-7 overflow-hidden relative z-20">
      <div className="w-full max-w-[1680px] mx-auto px-4 sm:px-8 lg:px-12 flex items-center gap-6 sm:gap-10">
        {/* Left Fixed Anchor Label */}
        <div className="shrink-0 pr-4 sm:pr-8 xl:border-r border-slate-200">
          <span className="text-[10px] sm:text-[11px] font-mono font-bold uppercase tracking-wider text-slate-400 whitespace-nowrap">CO-DESIGNED WITH GLOBAL LEADERS</span>
        </div>

        {/* Infinite Scrolling Track */}
        <div className="relative w-full overflow-hidden" style={{ maskImage: 'linear-gradient(to right, transparent 0, black 40px, black calc(100% - 40px), transparent 100%)' }}>
          <div className="marquee-track flex items-center gap-14 sm:gap-20">
            <LogoSet />
            <div aria-hidden="true" className="contents">
              <LogoSet />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          animation: marquee 30s linear infinite;
          width: max-content;
        }
        .marquee-track:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};
